export default __webpack_public_path__ + "static/media/Bonecleave.c6ddfc41.jpg";